module.exports = __webpack_public_path__ + "img/jfa.f0b48577.png";